import styled from "styled-components";

export const ContentContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  display: flex;
  flex-direction: row;
  gap: 28px;
  height: calc(100vh - 560px);
`;

export const ScrollbarContainer = styled.div`
  height: 100%;
  width: 100%;
  padding-right: 10px;
  display: flex;
  flex-direction: row;
  gap: 28px;
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const ErrorWrapper = styled.div`
  padding: 24px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const EmptyWrapper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  padding: 24px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.highClearGray};
  border-radius: 8px;
  background: ${(props) => props.theme.colors.white};
  margin: 0 auto;
`;

